import React from "react";

const FlashingLoader = () => {
  return <div className="dot-flashing"></div>;
};

export default FlashingLoader;
